import React from 'react';

function initials(name = '') {
  const parts = String(name || 'User').trim().split(/\s+/).filter(Boolean);
  return (parts.slice(0, 2).map((part) => part[0]).join('') || 'U').toUpperCase();
}

export default function ProfileAvatar({ src, name, role, size = 'md', className = '' }) {
  return (
    <span className={`profile-avatar profile-avatar-${size} ${className}`.trim()} title={[name, role].filter(Boolean).join(' · ')}>
      {src ? <img src={src} alt={name || role || 'Profile'} /> : <b>{initials(name || role)}</b>}
    </span>
  );
}
